/** Handle the value of the catch clause e.g. `e` in `try {} catch(e) {}` */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class CatchUtil {
  /** Convert unknown to Error. No-op if already an error. */
  public static toError(e: unknown): Error {
    if (e instanceof Error) {
      return e;
    }

    if (typeof e === 'string') {
      return new Error(e);
    }

    return new Error(`Unknown error type converting to string: ${e}`);
  }

  /** Convert unknown to Error then get its message. */
  public static getMessage(e: unknown): string {
    return CatchUtil.toError(e).message;
  }
}
